import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order, Response } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class PaypalService {
  constructor(private http: HttpClient) { }

  createOrder(orderType: string, user: any, data: any) {
    return this.http.post<Response<Order>>('api/v1/paypal/create-order', { ...data, user, orderType });
  }

  completeOrder(id: string, user: any, data: any) {
    return this.http.post<Response<Order>>('api/v1/paypal/complete-order', { ...data, user, _id: id });
  }
}
